import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { Respuesta, TmmvNodo } from '../_models/shared/_index';
import { SessionService } from './session.service';
import { ErrorService } from './error.service';

@Injectable()
export class GoogleOauthService {
	constructor(private http: HttpClient, private errorService: ErrorService) {}

	private checkAuthUrl: string =
		environment.rest + '/GoogleOAuth/CheckAuthorization';
	private getAuthorizationUrl: string =
		environment.rest + '/GoogleOAuth/GetAuthorization';
	private revokeAuthorizationUrl: string =
		environment.rest + '/GoogleOAuth/RevokeAuthorization';
	headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	public CheckAuthorization(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.get<Respuesta>(this.checkAuthUrl, options)
			.pipe(
				catchError(
					this.errorService.handleError<Respuesta>(`get CheckAuthorization`)
				)
			);
	}

	public GetAuthorization(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.getAuthorizationUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`get GetAuthorization`)
			)
		);
	}

	public RevokeAuthorization(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.get<Respuesta>(this.revokeAuthorizationUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`get RevokeAuthorization`)
			)
		);
	}

	// public getSegmentacionesPorNodos(nodos: Array<TmmvNodo>, idSegmentacion: number): Observable<Respuesta> {
	//     let options = { headers: this.headers, withCredentials: true };
	//     return this.http.post<Respuesta>(this.getSegmentacionesPorNodosUrl, { nodos, idSegmentacion }, options).pipe(
	//         catchError(this.errorService.handleError<Respuesta>(`get getSegmentacionesPorNodos`))
	//     );
	// }

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
